/* ============================================================
   MISS FOX — CRO JAVASCRIPT
   • Countdown timer (72hr rolling, stored in sessionStorage)
   • Low stock randomiser
   • Sticky ATC scroll trigger
   • Recent purchase pop (subtle)
   ============================================================ */

(function () {
  'use strict';

  /* ── COUNTDOWN TIMER ──────────────────────────────────── */
  function initCountdown() {
    var els = document.querySelectorAll('[data-mf-countdown]');
    if (!els.length) return;

    var KEY = 'mf_timer_end';
    var DURATION = 72 * 60 * 60 * 1000; // 72 hours in ms

    var stored = sessionStorage.getItem(KEY);
    var end;
    if (stored) {
      end = parseInt(stored, 10);
    } else {
      end = Date.now() + DURATION;
      sessionStorage.setItem(KEY, end);
    }

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var now = Date.now();
      var diff = end - now;
      if (diff < 0) {
        // Reset
        end = Date.now() + DURATION;
        sessionStorage.setItem(KEY, end);
        diff = DURATION;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      els.forEach(function (el) {
        var hEl = el.querySelector('[data-mf-h]');
        var mEl = el.querySelector('[data-mf-m]');
        var sEl = el.querySelector('[data-mf-s]');
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ── LOW STOCK NUMBER ─────────────────────────────────── */
  function initStockBadge() {
    var badge = document.querySelector('[data-mf-stock-num]');
    if (!badge) return;
    // Randomise between 7-14 once per session
    var KEY = 'mf_stock_num';
    var num = sessionStorage.getItem(KEY);
    if (!num) {
      num = Math.floor(Math.random() * 8) + 7; // 7-14
      sessionStorage.setItem(KEY, num);
    }
    badge.textContent = num;
  }

  /* ── STICKY ATC ───────────────────────────────────────── */
  function initStickyATC() {
    var sticky = document.querySelector('.mf-sticky-atc');
    var atc = document.querySelector('.product-form__submit');
    if (!sticky || !atc) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.style.display = entry.isIntersecting ? 'none' : '';
      });
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });

    observer.observe(atc);
  }

  /* ── STICKY ATC CLICK ─────────────────────────────────── */
  function initStickyATCClick() {
    var btn = document.querySelector('.mf-sticky-atc__btn');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var realBtn = document.querySelector('.product-form__submit');
      if (realBtn) {
        realBtn.click();
      }
    });
  }

  /* ── FAQ SMOOTH TOGGLE ────────────────────────────────── */
  function initFAQ() {
    var items = document.querySelectorAll('.mf-faq__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        // Close others when one opens
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        }
      });
    });
  }

  /* ── ADD BODY CLASS FOR MOBILE PADDING ───────────────── */
  function initBodyClass() {
    if (document.querySelector('.mf-sticky-atc')) {
      document.body.classList.add('mf-pdp');
    }
  }

  /* ── INIT ─────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    initStockBadge();
    initStickyATC();
    initStickyATCClick();
    initFAQ();
    initBodyClass();
  });

})();
